module.exports = __webpack_public_path__ + "img/email.1b653849.svg";